// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ArrowNE = function ArrowNE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.882 3.08c.575 0 1.038.463 1.038 1.038v10.378c0 .575-.463 1.038-1.038 1.038a1.036 1.036 0 0 1-1.038-1.038V6.622L4.85 16.615a1.037 1.037 0 0 1-1.467-1.466l9.994-9.989-7.878-.004a1.036 1.036 0 0 1-1.038-1.038c0-.575.463-1.038 1.038-1.038z"
  }));
};
